const types = {
    UPDATE_CURRENT_MENU: 'my-website/navigation/update-current-menu',
    UPDATE_CURRENT_MENU_ASYNC: 'my-website/navigation/update-current-menu-async',
}

export default types;